var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 58,
    viewBox: "0 0 43 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 58,
    fill: "#555555"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opportunite Page",
    clipPath: "url(#clip0_277_1320)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2893,
    transform: "translate(-884 -716)",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 388",
    filter: "url(#filter0_d_277_1320)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_277_1320",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-656 -69C-656 -72.3137 -653.314 -75 -650 -75H322C325.314 -75 328 -72.3137 328 -69V100C328 103.314 325.314 106 322 106H-650C-653.314 106 -656 103.314 -656 100V-69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-656 -69C-656 -72.3137 -653.314 -75 -650 -75H322C325.314 -75 328 -72.3137 328 -69V100C328 103.314 325.314 106 322 106H-650C-653.314 106 -656 103.314 -656 100V-69Z",
    fill: "url(#paint0_linear_277_1320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-657 -69C-657 -72.866 -653.866 -76 -650 -76H322C325.866 -76 329 -72.866 329 -69H327C327 -71.7614 324.761 -74 322 -74H-650C-652.761 -74 -655 -71.7614 -655 -69H-657ZM328 106H-656H328ZM-650 106C-653.866 106 -657 102.866 -657 99V-69C-657 -72.866 -653.866 -76 -650 -76V-74C-652.761 -74 -655 -71.7614 -655 -69V100C-655 103.314 -652.761 106 -650 106ZM322 -76C325.866 -76 329 -72.866 329 -69V99C329 102.866 325.866 106 322 106C324.761 106 327 103.314 327 100V-69C327 -71.7614 324.761 -74 322 -74V-76Z",
    fill: "#F2F2F2",
    mask: "url(#path-1-inside-1_277_1320)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6466 0C32.6299 0.268191 33.6133 0.625778 34.4179 1.43035C35.4012 2.41372 35.8482 3.57588 35.8482 4.91684C35.8482 5.63202 35.8482 6.43659 35.8482 7.24116C36.6528 7.24116 37.368 7.24116 38.0832 7.24116C40.9439 7.24116 42.9106 9.2973 43 12.158C43 12.2474 43 12.3368 43 12.4262C43 25.7464 43 39.0665 43 52.3867C43 54.4428 42.1954 56.052 40.3181 57.0354C39.8711 57.3035 39.3347 57.3929 38.7983 57.5717C27.2661 57.5717 15.8233 57.5717 4.29106 57.5717C3.0395 57.3035 1.96674 56.8566 1.16216 55.8732C0.357588 54.9792 0 53.9064 0 52.6549C0 39.1559 0 25.657 0 12.2474C0 9.65488 1.69854 7.95634 4.20166 7.41996C6.43659 6.97298 8.67152 6.2578 10.9064 5.63202C17.1642 3.93348 23.422 2.14553 29.6798 0.446985C29.948 0.357588 30.2162 0.268189 30.4844 0.178791C30.842 -2.73085e-06 31.289 0 31.6466 0ZM2.41372 32.3617C2.41372 33.2557 2.41372 34.2391 2.41372 35.1331C2.41372 40.8545 2.41372 46.5759 2.41372 52.2973C2.41372 53.1913 2.59251 53.9958 3.30769 54.5322C3.84407 54.9792 4.55925 55.0686 5.18503 55.0686C12.4262 55.0686 19.578 55.0686 26.8191 55.0686C30.4844 55.0686 34.2391 55.0686 37.9044 55.0686C38.8877 55.0686 39.6923 54.8004 40.2287 53.9958C40.4969 53.4595 40.6757 52.8337 40.6757 52.2079C40.6757 40.7651 40.6757 29.2329 40.6757 17.79C40.6757 15.9127 40.6757 14.1247 40.6757 12.2474C40.6757 11.4428 40.4969 10.7277 39.8711 10.1913C39.3347 9.65489 38.6195 9.56549 37.815 9.56549C32.6299 9.56549 27.3555 9.56549 22.1705 9.56549C16.5385 9.56549 10.817 9.56549 5.18503 9.56549C4.29106 9.56549 3.48648 9.74429 2.8607 10.5489C2.41372 11.0852 2.32432 11.8004 2.32432 12.4262C2.41372 19.0416 2.41372 25.657 2.41372 32.3617ZM33.4345 7.15177C33.4345 6.34719 33.4345 5.63202 33.4345 4.82744C33.3451 3.0395 32.0042 2.05614 30.3056 2.50312C25.2994 3.84408 20.3825 5.27443 15.3763 6.61539C14.9293 6.70478 14.3929 6.88358 13.9459 7.06237V7.15177C20.3825 7.15177 26.9085 7.15177 33.4345 7.15177Z",
    fill: "#2A5A16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5894 36.462C16.5666 36.462 12.4739 32.3073 12.4739 27.3465C12.4739 22.3236 16.5666 18.231 21.5894 18.231C26.6122 18.231 30.6429 22.3236 30.7049 27.3465C30.7049 32.3693 26.6122 36.462 21.5894 36.462ZM24.0698 26.4783C24.0078 24.742 23.7598 23.0678 23.0776 21.4555C22.8916 21.0834 22.6436 20.6494 22.3955 20.3393C21.8995 19.7192 21.4034 19.7192 20.9073 20.3393C20.7213 20.5874 20.5352 20.8354 20.4112 21.1454C19.8531 22.1996 19.5431 23.3778 19.419 24.556C19.357 25.1761 19.295 25.8582 19.233 26.5403C20.8453 26.4783 22.3955 26.4783 24.0698 26.4783ZM24.0698 28.2146C22.3955 28.2146 20.7833 28.2146 19.171 28.2146C19.233 29.8269 19.481 31.4392 20.0391 32.9274C20.2252 33.4235 20.5352 33.9816 20.9073 34.4157C21.3414 34.9738 21.8995 34.9738 22.3335 34.4157C22.5196 34.1676 22.7056 33.9196 22.8916 33.6095C23.6978 31.8732 23.9458 30.0749 24.0698 28.2146ZM24.5039 20.5253C24.7519 21.4555 25.124 22.4477 25.31 23.3778C25.4961 24.37 25.6201 25.4242 25.7441 26.4783C26.7983 26.4783 27.8524 26.4783 28.9066 26.4783C28.7206 23.6259 26.5502 21.2075 24.5039 20.5253ZM17.4347 26.4783C17.5587 25.4242 17.6827 24.37 17.8688 23.3778C18.0548 22.3857 18.4269 21.3935 18.6749 20.4013C16.1325 21.5795 14.6442 23.5639 14.2102 26.4163C15.3264 26.4783 16.3805 26.4783 17.4347 26.4783ZM28.9686 28.2146C27.8524 28.2146 26.7983 28.2146 25.7441 28.2146C25.6201 30.323 25.31 32.3073 24.3799 34.2296C26.7983 33.2995 28.6586 31.0051 28.9686 28.2146ZM17.4967 28.2146C16.3805 28.2146 15.3264 28.2146 14.2722 28.2146C14.5822 31.2531 16.8766 33.5475 18.7989 34.2296C17.9308 32.3073 17.6207 30.261 17.4967 28.2146Z",
    fill: "#2A5A16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5144 44.1384H31.6645M14.7308 47.9765H27.5963",
    stroke: "#2A5A16",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_277_1320",
    x: -664,
    y: -83,
    width: 1000,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196875 0 0 0 0 0.21644 0 0 0 0 0.225 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_277_1320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_277_1320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_1320",
    x1: -164,
    y1: -75,
    x2: -164,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2893,
    fill: "white",
    transform: "translate(-884 -716)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.e534729926ec5aa8b73a3afcf3a6afff.svg";
export { ForwardRef as ReactComponent };